import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/useAuthStore'
import { useFilterStore } from '@/stores/useFilterStore'
import { getAuth } from 'firebase/auth'

const Login = () => import('@/views/Login.vue')
const Panel = () => import('@/views/Panel.vue')
const Browse = () => import('@/views/Panel/Browse.vue')
const CookiesPolicy = () => import('@/views/CookiesPolicy.vue')
const PrivacyPolicy = () => import('@/views/PrivacyPolicy.vue')
const TermsOfService = () => import('@/views/TermsOfService.vue')
const Profile = () => import('@/views/Profile.vue')
const Subscription = () => import('@/views/Subscription.vue')
const Orders = () => import('@/views/Orders.vue')

async function setupFiltering(to: any, from: any, next: any) {
  const filterStore = useFilterStore()
  if (to.query.category !== undefined) filterStore.setCategory(parseInt(to.query.category))
  else if (to.query.tag !== undefined) filterStore.setTag(to.query.tag)
  // ?diagram_name= is a deep link resolved by Browse.vue against Typesense. It must
  // not seed the filter store: diagram/slide filters hold numeric IDs, so a name here
  // reaches Typesense as id:=[<name>] and matches nothing (and can wipe the deep link).
  if (to.query.diagram_name === undefined) {
    if (to.query.diagram !== undefined) filterStore.setDiagram(to.query.diagram)
    if (to.query.slide !== undefined) filterStore.setSlide(to.query.slide)
  }
  if (to.query.search !== undefined) filterStore.setQuery(to.query.search)
  if (to.query.my === 'true') filterStore.setMy(true)
  next()
}

const routes: RouteRecordRaw[] = [
  { path: '/', name: 'login', component: Login },
  {
    path: '/panel',
    component: Panel,
    props: true,
    meta: { auth: true },
    beforeEnter: setupFiltering,
    children: [
      { path: '', redirect: 'browse/' },
      { path: 'browse/', component: Browse, name: 'browse' },
      { path: 'diagrams/', redirect: (to: any) => ({ name: 'browse', query: to.query }) },
      { path: 'slides/', redirect: (to: any) => ({ name: 'browse', query: to.query }) }
    ]
  },
  { path: '/cookies-policy', name: 'cookies-policy', component: CookiesPolicy },
  { path: '/profile', name: 'profile', component: Profile },
  { path: '/subscription', name: 'subscription', component: Subscription },
  { path: '/orders', name: 'orders', component: Orders, meta: { auth: true } },
  { path: '/privacy-policy', name: 'privacy-policy', component: PrivacyPolicy },
  { path: '/terms-of-services', name: 'terms-of-service', component: TermsOfService }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  if (to.query.token) {
    authStore.login(to.query.token as string)
    const query = { ...to.query }
    delete (query as any).token
    return next({ name: to.name as string, query })
  }
  if (to.name === 'login' && authStore.isLogged) {
    return next({ name: 'browse' })
  }
  if (to.meta.auth) {
    const firebaseUser = getAuth().currentUser
    if (authStore.isLogged || firebaseUser) {
      if (firebaseUser && !authStore.email) authStore.setEmail(firebaseUser.email)
      next()
    } else {
      next({ name: 'login' })
    }
  } else next()
})

export default router
